import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {initReactI18next} from "react-i18next";
import XHR from "i18next-xhr-backend";

import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationPT from './locales/pt/translation.json';

i18n
    .use(XHR)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        // we init with resources
        resources: {
            en: {
                translations: translationEN
            },
            pt: {
                translations: translationPT
            },
            es: {
                translations: translationES
            },
        },
        fallbackLng: "en",
        debug: false,
        // have a common namespace used around the full app
        ns: ["translations"],
        defaultNS: "translations",
        transSupportBasicHtmlNodes: true,
        keySeparator: false, // we use content as keys
        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ","
        },
        react: {
            wait: true,
            useSuspense: false,
        }
    });

export default i18n;
